/**
 * Get API path from environment,
 */
export const API_BASE_URL =
  process.env["REACT_APP_API_BASE_URL"] === undefined
    ? "/api"
    : process.env["REACT_APP_API_BASE_URL"];

/**
 * HTTP Status Codes enum. We add -1 as a special case when the request fails to complete (rejected fetch promise).
 */
export enum HttpStatusCodes {
  RequestFailed = -1,
  OK = 200,
  Unauthorized = 401,
  NotFound = 404,
  InternalServerError = 500,
  ServiceUnavailable = 503,
}

/** Paginated response from the API */
export type PaginatedResponse<T> = [
  HttpStatusCodes,
  {
    count: number;
    page: number;
    pageSize: number;
    data: T;
  } | null
];

export type Response<T> = [HttpStatusCodes, T | null];
